import { Promotion } from '../../../../stores/promotion';
import { GameRegionTag } from '../../../../utils/games';

const renderRegion = (_: unknown, record: Promotion) => {
    return <GameRegionTag region={record.promotionProvinces || []} />;
};

export default renderRegion;
